import { WarrantyLogInput, WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export const useWarrantyLogMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WarrantyLogService.postWarrantyLog>>,
      QueryError,
      WarrantyLogInput,
      unknown
    >,
    'mutationFn'
  >
) => useMutation((input: WarrantyLogInput) => WarrantyLogService.postWarrantyLog(input), options);
